import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4" data-id="element-96">
      <div className="max-w-3xl mx-auto" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="glass-panel border-2 border-[#39FF14]/30 rounded-2xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-98">
          <div className="absolute inset-0 bg-gradient-to-b from-[#39FF14]/5 to-transparent pointer-events-none" data-id="element-99"></div>

          <div className="inline-flex items-center justify-center p-4 bg-[#39FF14]/10 rounded-full mb-6 text-[#39FF14] drop-shadow-[0_0_15px_rgba(57,255,20,0.5)]" data-id="element-100">
            <ShieldCheckIcon size={64} data-id="element-101" />
          </div>

          <h2 className="text-3xl font-black mb-6 font-orbitron tracking-wide" data-id="element-102">
            GARANTÍA "RIESGO CERO"
          </h2>

          <p className="text-lg text-gray-300 leading-relaxed" data-id="element-103">
            Si después de leer las primeras 10 páginas sientes que esto no es
            para ti o que no has aprendido nada nuevo, envíanos un email en los
            primeros 7 días y te devolveremos el 100% de tu dinero. Sin
            preguntas, sin resentimientos.{' '}
            <strong className="text-white" data-id="element-104">El riesgo es todo nuestro.</strong>
          </p>
        </motion.div>
      </div>
    </section>;
}